import { Badge, Group, Tooltip } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { isActiveTag, tagsApi, type AssignedTag } from "../../api/tags";
import { formatDateTime } from "../../lib/format";

/** The tag catalogue, cached for every chip on the page. */
export function useTagCatalogue() {
  return useQuery({ queryKey: ["tags"], queryFn: () => tagsApi.list(), staleTime: 60_000 });
}

/** Chips for an account's unexpired tags (list rows). */
export function TagChips({ tags }: { tags?: AssignedTag[] | null }) {
  const { data: catalogue } = useTagCatalogue();
  const active = (tags ?? []).filter(isActiveTag);
  if (!active.length) return null;
  return (
    <Group gap={4} wrap="wrap">
      {active.map((t) => {
        const def = catalogue?.find((c) => c.key === t.key);
        return (
          <Tooltip
            key={t.key}
            label={t.expiresAt ? `Until ${formatDateTime(t.expiresAt)}` : "No expiry"}
            withArrow
          >
            <Badge size="xs" variant="light" color={def?.color ?? "gray"}>
              {def?.label ?? t.key}
            </Badge>
          </Tooltip>
        );
      })}
    </Group>
  );
}
